<template>
  <div class="emoji-picker" @mousedown.stop>
    <div class="emoji-top">
      <input
        v-model="query"
        type="text"
        class="emoji-search"
        placeholder="Buscar emoji..."
      />
      <button class="emoji-close" @click="$emit('close')" aria-label="Fechar">×</button>
    </div>

    <div class="emoji-tabs">
      <button
        v-for="c in categories"
        :key="c.key"
        class="emoji-tab"
        :class="{ active: c.key === activeCategory }"
        @click="activeCategory = c.key"
        type="button"
      >
        <span>{{ c.icon }}</span>
      </button>
    </div>

    <div class="emoji-grid">
      <button
        v-for="e in filteredEmojis"
        :key="e"
        class="emoji-item"
        type="button"
        @click="selectEmoji(e)"
        :title="emojiTitle(e)"
      >{{ e }}</button>

      <div v-if="!filteredEmojis.length" class="emoji-empty">Nada encontrado</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmojiPicker',
  props: {
    recent: {
      type: Array,
      default: function () { return [] }
    }
  },
  data: function () {
    return {
      query: '',
      activeCategory: 'recent',
      categories: [
        { key: 'recent', icon: '🕘' },
        { key: 'smileys', icon: '😀' },
        { key: 'gestures', icon: '👍' },
        { key: 'animals', icon: '🐶' },
        { key: 'food', icon: '🍕' },
        { key: 'activities', icon: '⚽' },
        { key: 'travel', icon: '🚗' },
        { key: 'objects', icon: '💡' },
        { key: 'symbols', icon: '❤️' }
      ],
      emojiMap: {
        smileys: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '🙄', '😬', '😮‍💨', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧'],
        gestures: ['👍', '👎', '👌', '🤌', '🤞', '✌️', '🤟', '🤘', '🤙', '👋', '🤚', '✋', '🖐️', '🖖', '👏', '🙌', '👐', '🤝', '🙏', '💪', '🦾', '🖕', '✊', '👊', '🤛', '🤜', '🤲', '🫶', '🫵'],
        animals: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐔', '🐧', '🐦', '🐤', '🐣', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🦋', '🐌', '🐞', '🐜', '🪲', '🕷️', '🦂', '🐢', '🐍', '🦎', '🐙', '🦑', '🦐', '🦞', '🐠', '🐟', '🐬', '🐳', '🐊', '🦈'],
        food: ['🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🥑', '🥦', '🥕', '🌽', '🥔', '🍠', '🥐', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳', '🥞', '🥓', '🍗', '🍖', '🌭', '🍔', '🍟', '🍕', '🥪', '🌮', '🌯', '🥙', '🍣', '🍱', '🍛', '🍜', '🍝', '🍤', '🍦', '🍩', '🍪', '🎂', '🍰', '🧁', '🍫', '🍬', '🍭', '☕', '🍺', '🍻', '🥤', '🧃'],
        activities: ['⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🥏', '🎱', '🏓', '🏸', '🥊', '🥋', '🎮', '🕹️', '🎲', '♟️', '🎯', '🎳', '🎣', '🎨', '🎭', '🎤', '🎧', '🎹', '🥁', '🎺', '🎸', '🎻', '🏆', '🏅', '🥇', '🥈', '🥉'],
        travel: ['🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚚', '🚛', '🚜', '🛵', '🏍️', '🚲', '✈️', '🛫', '🛬', '🚀', '🛸', '🚁', '⛵', '🛶', '🚤', '🚢', '🗺️', '🧭', '🏖️', '🏕️', '🏟️', '🎡', '🎢', '🎠', '🗽', '🗼', '🏰', '⛩️', '🕌', '🏔️', '🌋', '🗻', '🏝️'],
        objects: ['⌚', '📱', '💻', '🖥️', '⌨️', '🖱️', '🖨️', '💽', '💾', '💿', '📀', '📷', '📸', '🎥', '📹', '🔦', '💡', '🕯️', '🔌', '🔋', '📡', '🧯', '🧲', '💰', '💳', '🧾', '📦', '✉️', '📩', '🗳️', '📝', '📌', '📍', '📎', '🔒', '🔓', '🔑', '🔨', '🪛', '🔧', '🪚', '⚙️', '🧰'],
        symbols: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '✅', '☑️', '❌', '❗', '❓', '‼️', '⁉️', '⚠️', '🚫', '🎵', '🎶', '✨', '💥', '🔥', '💧', '🌟', '⭐', '🌈', '☀️', '🌙', '☁️', '⛈️', '❄️']
      },

      emojiKeywords: {
        // ❤️ CORAÇÕES / AMOR
        '❤️': ['coracao', 'coração', 'amor', 'amei', 'amo', 'gosto', 'carinho', 'romance', 'paixao', 'paixão'],
        '🧡': ['coracao', 'coração', 'amor', 'laranja', 'carinho'],
        '💛': ['coracao', 'coração', 'amor', 'amarelo', 'alegria', 'feliz'],
        '💚': ['coracao', 'coração', 'amor', 'verde', 'esperanca', 'esperança', 'saude', 'saúde'],
        '💙': ['coracao', 'coração', 'amor', 'azul', 'calma', 'tranquilo', 'tranquila'],
        '💜': ['coracao', 'coração', 'amor', 'roxo', 'carinho'],
        '🖤': ['coracao', 'coração', 'amor', 'preto', 'luto', 'triste'],
        '🤍': ['coracao', 'coração', 'amor', 'branco', 'paz'],
        '🤎': ['coracao', 'coração', 'amor', 'marrom'],
        '💔': ['coracao', 'coração', 'partido', 'termino', 'término', 'desilusão', 'desilusao', 'triste', 'sofrendo'],
        '💕': ['amor', 'carinho', 'fofo', 'fofa', 'apaixonado', 'apaixonada'],
        '💞': ['amor', 'carinho', 'juntos', 'casal'],
        '💓': ['amor', 'coração', 'coracao', 'batendo', 'paixao', 'paixão'],
        '💗': ['amor', 'carinho', 'coração', 'coracao'],
        '💖': ['amor', 'brilho', 'carinho', 'lindo', 'linda'],
        '💘': ['cupido', 'amor', 'paixao', 'paixão', 'flecha'],
        '💝': ['presente', 'amor', 'carinho'],
        '💟': ['coração', 'coracao', 'amor'],
        '❣️': ['amor', 'coração', 'coracao'],

        // 😀 SORRISO / FELIZ
        '😀': ['feliz', 'sorriso', 'alegre', 'bom', 'boa'],
        '😃': ['feliz', 'sorriso', 'alegre'],
        '😄': ['feliz', 'sorriso', 'alegre', 'animado', 'animada'],
        '😁': ['feliz', 'sorriso', 'rindo', 'alegre'],
        '😆': ['rindo', 'risada', 'haha', 'engracado', 'engraçado', 'muito bom'],
        '😅': ['alivio', 'alívio', 'suor', 'nervoso', 'nervosa', 'ufa'],
        '😂': ['rir', 'rindo', 'risada', 'morrendo de rir', 'engracado', 'engraçado'],
        '🤣': ['rir', 'rindo', 'risada', 'muito engraçado', 'muito engraçada'],
        '😊': ['feliz', 'sorriso', 'fofo', 'fofa', 'querido', 'querida', 'gentil'],
        '😇': ['anjo', 'inocente', 'santo', 'santa'],
        '🙂': ['ok', 'tranquilo', 'tranquila', 'de boa'],
        '🙃': ['ironia', 'sarcasmo', 'zoeira', 'brincadeira'],
        '😉': ['piscadinha', 'piscar', 'safado', 'safada', 'malicia', 'malícia'],
        '😌': ['aliviado', 'aliviada', 'paz', 'calmo', 'calma'],
        '😍': ['apaixonado', 'apaixonada', 'amei', 'lindo', 'linda', 'perfeito', 'perfeita'],
        '🥰': ['amor', 'carinho', 'fofo', 'fofa', 'apaixonado', 'apaixonada'],
        '😘': ['beijo', 'bj', 'beijinho', 'carinho'],
        '😗': ['beijo', 'beijinho'],
        '😙': ['beijo', 'beijinho'],
        '😚': ['beijo', 'beijinho'],
        '😋': ['delicia', 'delícia', 'gostoso', 'gostosa', 'hmm'],
        '😛': ['lingua', 'língua', 'brincadeira', 'zoeira'],
        '😝': ['zoeira', 'brincadeira', 'doido', 'doida'],
        '😜': ['zoeira', 'brincadeira', 'piscadinha'],
        '🤪': ['doido', 'doida', 'loucura', 'maluco', 'maluca'],
        '🤨': ['desconfiado', 'desconfiada', 'suspeito', 'suspeita', 'serio', 'sério'],
        '🧐': ['analisando', 'pensando', 'investigando', 'olhando'],
        '🤓': ['nerd', 'estudando', 'inteligente'],
        '😎': ['top', 'legal', 'maneiro', 'descolado', 'descolada'],
        '🥳': ['festa', 'comemorar', 'parabens', 'parabéns', 'aniversario', 'aniversário'],
        '😏': ['malandro', 'malandra', 'safado', 'safada', 'ironia'],
        '😒': ['chato', 'chateado', 'chateada', 'tanto faz', 'aff'],
        '😞': ['triste', 'deprimido', 'deprimida', 'desanimado', 'desanimada'],
        '😔': ['triste', 'pensativo', 'pensativa', 'chateado', 'chateada'],
        '😟': ['preocupado', 'preocupada', 'ansioso', 'ansiosa'],
        '😕': ['confuso', 'confusa', 'nao entendi', 'não entendi', 'meh'],
        '🙁': ['triste', 'chateado', 'chateada'],
        '☹️': ['triste', 'chateado', 'chateada'],
        '😣': ['sofrendo', 'dor', 'difícil', 'dificil', 'tenso', 'tensa'],
        '😖': ['dor', 'tenso', 'tensa', 'aff'],
        '😫': ['cansado', 'cansada', 'exausto', 'exausta', 'tenso', 'tensa'],
        '😩': ['cansado', 'cansada', 'exausto', 'exausta'],
        '🥺': ['por favor', 'carente', 'fofo', 'fofa', 'chorando'],
        '😢': ['choro', 'chorando', 'triste'],
        '😭': ['chorando', 'muito triste', 'desespero'],
        '😤': ['irritado', 'irritada', 'bufando', 'raiva'],
        '😠': ['raiva', 'bravo', 'brava', 'irritado', 'irritada'],
        '😡': ['raiva', 'muito bravo', 'muito brava', 'odio', 'ódio'],
        '🤬': ['xingar', 'raiva', 'palavrão', 'estressado', 'estressada'],
        '🤯': ['mente explodindo', 'explodiu', 'surpreso', 'surpresa', 'chocado', 'chocada'],
        '😳': ['vergonha', 'tímido', 'timido', 'tímida', 'timida', 'sem graça'],
        '🥵': ['calor', 'quente', 'suando'],
        '🥶': ['frio', 'gelado', 'gelada'],
        '😱': ['medo', 'assustado', 'assustada', 'pavor', 'horror'],
        '😨': ['medo', 'assustado', 'assustada'],
        '😰': ['nervoso', 'nervosa', 'ansioso', 'ansiosa', 'suor'],
        '😥': ['triste', 'alívio', 'alivio', 'suor'],
        '😓': ['suor', 'cansado', 'cansada', 'nervoso', 'nervosa'],
        '🤗': ['abraço', 'abraco', 'carinho', 'acolher'],
        '🤔': ['pensando', 'duvida', 'dúvida', 'hmm'],
        '🤭': ['risinho', 'vergonha', 'ops'],
        '🤫': ['silencio', 'silêncio', 'shhh', 'segredo'],
        '🤥': ['mentira', 'mentiroso', 'mentirosa'],
        '😶': ['sem palavras', 'calado', 'calada'],
        '😐': ['neutro', 'tanto faz', 'ok'],
        '😑': ['sem graça', 'chato', 'aff'],
        '🙄': ['revirar os olhos', 'olhos', 'aff', 'ironia'],
        '😬': ['tenso', 'tensa', 'constrangido', 'constrangida'],
        '😮‍💨': ['suspiro', 'cansado', 'cansada', 'alivio', 'alívio'],
        '😴': ['sono', 'dormindo', 'cansado', 'cansada'],
        '🤤': ['fome', 'gostoso', 'gostosa', 'babando'],
        '😪': ['sono', 'cansado', 'cansada'],
        '😵': ['tonto', 'tonta', 'confuso', 'confusa'],
        '🤐': ['boca fechada', 'segredo', 'sem comentar'],
        '🥴': ['doido', 'doida', 'tonto', 'tonta', 'bebado', 'bêbado'],
        '🤢': ['nojo', 'enjoo', 'enjoado', 'enjoada'],
        '🤮': ['vomito', 'vômito', 'passando mal'],
        '🤧': ['gripe', 'resfriado', 'espirro', 'alergia', 'alergia'],

        // 👍 GESTOS
        '👍': ['joinha', 'ok', 'beleza', 'bom', 'boa', 'aprovado', 'aprovada', 'positivo'],
        '👎': ['nao', 'não', 'ruim', 'reprovado', 'reprovada', 'negativo'],
        '👌': ['ok', 'perfeito', 'fechado', 'beleza'],
        '🤌': ['italiano', 'que isso', 'oq', 'o que', 'que'],
        '🤞': ['torcendo', 'boa sorte', 'sorte'],
        '✌️': ['paz', 'vitoria', 'vitória', 'dois'],
        '🤟': ['eu te amo', 'te amo', 'amor', 'rock'],
        '🤘': ['rock', 'metal', 'show'],
        '🤙': ['ligar', 'chamar', 'telefone'],
        '👋': ['tchau', 'oi', 'olá', 'ola', 'adeus'],
        '🤚': ['pare', 'stop', 'mão'],
        '✋': ['pare', 'stop', 'mão'],
        '🖐️': ['mão', 'cinco'],
        '🖖': ['vida longa', 'spock'],
        '👏': ['palmas', 'aplausos', 'parabens', 'parabéns'],
        '🙌': ['comemorar', 'alegria', 'vitoria', 'vitória'],
        '👐': ['aberto', 'abertura', 'mãos'],
        '🤝': ['acordo', 'fechado', 'aperto de mao', 'aperto de mão', 'parceria'],
        '🙏': ['obrigado', 'por favor', 'desculpa', 'rezar', 'oração', 'oracao'],
        '💪': ['forca', 'força', 'forte', 'treino', 'academia'],
        '🖕': ['xingar', 'raiva', 'nervoso', 'nervosa'],
        '✊': ['forca', 'força', 'luta'],
        '👊': ['soco', 'fechado', 'bro', 'parceria'],
        '🤛': ['soco', 'soquinho'],
        '🤜': ['soco', 'soquinho'],
        '🤲': ['mãos', 'pedir', 'oferecer'],
        '🫶': ['amor', 'coração', 'coracao', 'carinho'],
        '🫵': ['você', 'tu', 'vc'],

        // 🐶 ANIMAIS (principais)
        '🐶': ['cachorro', 'cao', 'cão', 'dog', 'pet'],
        '🐱': ['gato', 'cat', 'pet'],
        '🐭': ['rato', 'mouse'],
        '🐰': ['coelho'],
        '🦊': ['raposa'],
        '🐻': ['urso'],
        '🐼': ['panda'],
        '🐨': ['coala'],
        '🐯': ['tigre'],
        '🦁': ['leao', 'leão'],
        '🐮': ['vaca', 'boi'],
        '🐷': ['porco'],
        '🐸': ['sapo'],
        '🐵': ['macaco'],
        '🙈': ['nao vejo', 'não vejo', 'vergonha'],
        '🙉': ['nao ouço', 'não ouço'],
        '🙊': ['nao falo', 'não falo', 'segredo'],
        '🐔': ['galinha'],
        '🐧': ['pinguim'],
        '🐦': ['passaro', 'pássaro'],
        '🦆': ['pato'],
        '🦅': ['aguia', 'águia'],
        '🦉': ['coruja'],
        '🦇': ['morcego'],
        '🐺': ['lobo'],
        '🦄': ['unicórnio', 'unicornio'],
        '🐝': ['abelha'],
        '🦋': ['borboleta'],
        '🐌': ['caracol'],
        '🐞': ['joaninha'],
        '🐜': ['formiga'],
        '🕷️': ['aranha'],
        '🦂': ['escorpiao', 'escorpião'],
        '🐢': ['tartaruga'],
        '🐍': ['cobra'],
        '🐙': ['polvo'],
        '🦐': ['camarao', 'camarão'],
        '🐠': ['peixe'],
        '🐬': ['golfinho'],
        '🐳': ['baleia'],
        '🐊': ['jacare', 'jacaré'],
        '🦈': ['tubarao', 'tubarão'],

        // 🍕 COMIDA (principais)
        '🍏': ['maça', 'maca', 'apple', 'fruta'],
        '🍎': ['maça', 'maca', 'fruta'],
        '🍌': ['banana', 'fruta'],
        '🍉': ['melancia', 'fruta'],
        '🍇': ['uva', 'fruta'],
        '🍓': ['morango', 'fruta'],
        '🍒': ['cereja', 'fruta'],
        '🍍': ['abacaxi', 'fruta'],
        '🥥': ['coco', 'fruta'],
        '🍅': ['tomate'],
        '🥑': ['abacate'],
        '🥦': ['brocolis', 'brócolis'],
        '🥕': ['cenoura'],
        '🌽': ['milho'],
        '🥔': ['batata'],
        '🍞': ['pao', 'pão'],
        '🥐': ['croissant'],
        '🧀': ['queijo'],
        '🥚': ['ovo'],
        '🍳': ['ovo', 'cafe da manha', 'café da manhã'],
        '🥓': ['bacon'],
        '🍗': ['frango'],
        '🍖': ['carne'],
        '🌭': ['cachorro quente', 'hot dog'],
        '🍔': ['hamburguer', 'hambúrguer', 'lanche'],
        '🍟': ['batata frita', 'frita'],
        '🍕': ['pizza'],
        '🥪': ['sanduiche', 'sanduíche'],
        '🌮': ['taco'],
        '🍣': ['sushi', 'comida japonesa'],
        '🍛': ['curry'],
        '🍜': ['macarrao', 'macarrão', 'lamen', 'lámen'],
        '🍝': ['macarrao', 'macarrão'],
        '🍦': ['sorvete'],
        '🍩': ['donut'],
        '🍪': ['biscoito', 'cookie'],
        '🎂': ['bolo', 'aniversario', 'aniversário'],
        '🍰': ['bolo', 'doce'],
        '🧁': ['cupcake', 'doce'],
        '🍫': ['chocolate'],
        '🍬': ['bala', 'doce'],
        '🍭': ['pirulito', 'doce'],
        '☕': ['cafe', 'café'],
        '🍺': ['cerveja', 'bebida'],
        '🍻': ['cerveja', 'brinde'],
        '🥤': ['refrigerante', 'bebida'],
        '🧃': ['suco', 'bebida'],

        // ⚽ ATIVIDADES / ESPORTES / LAZER
        '⚽': ['futebol', 'bola'],
        '🏀': ['basquete', 'bola'],
        '🏈': ['futebol americano'],
        '⚾': ['baseball'],
        '🎾': ['tenis', 'tênis'],
        '🏐': ['volei', 'vôlei'],
        '🎱': ['sinuca', 'bilhar'],
        '🏓': ['ping pong', 'tenis de mesa', 'tênis de mesa'],
        '🥊': ['boxe', 'luta'],
        '🥋': ['karate', 'luta'],
        '🎮': ['jogo', 'game', 'videogame'],
        '🕹️': ['arcade', 'game'],
        '🎲': ['dado', 'jogo'],
        '♟️': ['xadrez'],
        '🎯': ['alvo', 'acertar'],
        '🎳': ['boliche'],
        '🎣': ['pesca', 'pescando'],
        '🎨': ['arte', 'pintar', 'desenho'],
        '🎭': ['teatro', 'drama'],
        '🎤': ['microfone', 'cantar', 'karaoke'],
        '🎧': ['musica', 'música', 'fone', 'headphone'],
        '🎹': ['piano', 'musica', 'música'],
        '🥁': ['bateria', 'musica', 'música'],
        '🎸': ['guitarra', 'musica', 'música'],
        '🏆': ['trofeu', 'troféu', 'campeao', 'campeão', 'vitoria', 'vitória'],
        '🏅': ['medalha'],
        '🥇': ['ouro', 'primeiro'],
        '🥈': ['prata', 'segundo'],
        '🥉': ['bronze', 'terceiro'],

        // 🚗 VIAGEM / TRANSPORTE / LUGARES
        '🚗': ['carro', 'veiculo', 'veículo'],
        '🚕': ['taxi', 'táxi'],
        '🚌': ['onibus', 'ônibus'],
        '🚎': ['onibus', 'ônibus'],
        '🏎️': ['corrida', 'carro', 'rapido', 'rápido'],
        '🚓': ['policia', 'polícia'],
        '🚑': ['ambulancia', 'ambulância', 'socorro'],
        '🚒': ['bombeiro'],
        '🚚': ['caminhao', 'caminhão'],
        '🚛': ['caminhao', 'caminhão'],
        '🚜': ['trator'],
        '🛵': ['moto', 'scooter'],
        '🏍️': ['moto'],
        '🚲': ['bicicleta', 'bike'],
        '✈️': ['aviao', 'avião', 'voo', 'viagem'],
        '🛫': ['decolagem', 'viagem', 'aviao', 'avião'],
        '🛬': ['pouso', 'viagem', 'aviao', 'avião'],
        '🚀': ['foguete', 'espaco', 'espaço'],
        '🛸': ['ovni', 'alien', 'extraterrestre'],
        '🚁': ['helicoptero', 'helicóptero'],
        '⛵': ['barco', 'vela'],
        '🛶': ['canoa'],
        '🚤': ['lancha'],
        '🚢': ['navio'],
        '🗺️': ['mapa', 'viagem'],
        '🧭': ['bussola', 'bússola', 'direcao', 'direção'],
        '🏖️': ['praia', 'ferias', 'férias'],
        '🏕️': ['acampamento', 'camping'],
        '🏟️': ['estadio', 'estádio'],
        '🎡': ['parque', 'roda gigante'],
        '🎢': ['montanha russa', 'parque'],
        '🗽': ['estatua', 'estátua', 'liberdade'],
        '🗼': ['torre', 'paris'],
        '🏰': ['castelo'],
        '⛩️': ['templo'],
        '🕌': ['mesquita'],
        '🏔️': ['montanha'],
        '🌋': ['vulcao', 'vulcão'],
        '🗻': ['montanha'],
        '🏝️': ['ilha', 'praia'],

        // 💡 OBJETOS / TRABALHO / TECH
        '⌚': ['relogio', 'relógio', 'hora'],
        '📱': ['celular', 'telefone'],
        '💻': ['computador', 'pc', 'notebook'],
        '🖥️': ['computador', 'monitor'],
        '⌨️': ['teclado'],
        '🖱️': ['mouse'],
        '🖨️': ['impressora'],
        '📷': ['camera', 'câmera', 'foto'],
        '📸': ['foto', 'camera', 'câmera'],
        '🎥': ['filme', 'video', 'vídeo'],
        '📹': ['video', 'vídeo', 'camera', 'câmera'],
        '🔦': ['lanterna'],
        '💡': ['ideia', 'luz', 'lampada', 'lâmpada', 'dica'],
        '🕯️': ['vela'],
        '🔌': ['tomada', 'energia'],
        '🔋': ['bateria', 'carregando'],
        '📡': ['antena', 'sinal'],
        '🧯': ['extintor'],
        '🧲': ['ima', 'ímã'],
        '💰': ['dinheiro', 'grana', 'rico'],
        '💳': ['cartao', 'cartão', 'credito', 'crédito', 'debito', 'débito'],
        '🧾': ['nota', 'recibo'],
        '📦': ['caixa', 'encomenda', 'pacote'],
        '✉️': ['email', 'carta'],
        '📩': ['email', 'mensagem'],
        '🗳️': ['urna', 'voto'],
        '📝': ['anotar', 'nota', 'escrever'],
        '📌': ['fixar', 'pin'],
        '📍': ['local', 'localizacao', 'localização'],
        '📎': ['clipe', 'anexo'],
        '🔒': ['cadeado', 'seguranca', 'segurança', 'trancado'],
        '🔓': ['destrancado', 'aberto'],
        '🔑': ['chave'],
        '🔨': ['martelo', 'ferramenta'],
        '🪛': ['chave de fenda', 'ferramenta'],
        '🔧': ['ajuste', 'consertar', 'ferramenta'],
        '🪚': ['serra', 'ferramenta'],
        '⚙️': ['config', 'configuracao', 'configuração', 'engrenagem'],
        '🧰': ['caixa de ferramentas', 'ferramenta'],

        // ✅ SÍMBOLOS / ALERTAS / STATUS
        '✅': ['ok', 'certo', 'confirmar', 'sucesso', 'check'],
        '☑️': ['marcar', 'check', 'ok'],
        '❌': ['x', 'erro', 'cancelar', 'nao', 'não'],
        '❗': ['atencao', 'atenção', 'importante'],
        '❓': ['duvida', 'dúvida', 'pergunta'],
        '‼️': ['urgente', 'importante'],
        '⁉️': ['que', 'como assim', 'duvida', 'dúvida'],
        '⚠️': ['alerta', 'cuidado', 'atencao', 'atenção'],
        '🚫': ['proibido', 'bloqueado', 'nao', 'não'],
        '🎵': ['musica', 'música'],
        '🎶': ['musica', 'música'],
        '✨': ['brilho', 'lindo', 'perfeito', 'especial'],
        '💥': ['boom', 'explosao', 'explosão'],
        '🔥': ['fogo', 'top', 'quente', 'bombando'],
        '💧': ['agua', 'água', 'gota', 'chuva'],
        '🌟': ['estrela', 'top', 'brilho'],
        '⭐': ['estrela', 'favorito', 'favorita'],
        '🌈': ['arco iris', 'arco-iris', 'colorido'],
        '☀️': ['sol', 'calor', 'dia'],
        '🌙': ['lua', 'noite'],
        '☁️': ['nuvem', 'tempo'],
        '⛈️': ['tempestade', 'chuva', 'trovao', 'trovão'],
        '❄️': ['frio', 'neve']
      }
    }
  },
  computed: {
    filteredEmojis: function () {
      var list
      if (this.activeCategory === 'recent') {
        list = Array.isArray(this.recent) ? this.recent : []
      } else {
        list = this.emojiMap[this.activeCategory] || []
      }

      var q = (this.query || '').toLowerCase().trim()
      if (!q) return list

      // Normaliza acentos simples (pt-br)
      q = this.normalizeText(q)

      var keywordMap = this.emojiKeywords || {}

      return list.filter(function (e) {
        // Se o usuário colar o próprio emoji, funciona também
        if (String(e).indexOf(q) !== -1) return true

        var keys = keywordMap[e]
        if (!Array.isArray(keys)) return false

        // compara normalizado
        for (var i = 0; i < keys.length; i++) {
          if (String(keys[i]).indexOf(q) !== -1) return true
        }
        return false
      })
    }
  },
  methods: {
    selectEmoji: function (emoji) {
      this.$emit('select', emoji)
    },
    normalizeText: function (str) {
      // remove acentos sem depender de lib externa (Node 14 + browser ok)
      // fallback seguro caso normalize não exista
      try {
        return String(str)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
      } catch (e) {
        return String(str).toLowerCase()
      }
    },
    emojiTitle: function (emoji) {
      // title com keywords (ajuda debug/UX)
      var keys = this.emojiKeywords && this.emojiKeywords[emoji]
      if (!keys || !keys.length) return emoji
      return emoji + ' • ' + keys.join(', ')
    }
  }
}
</script>

<style scoped>
.emoji-picker {
  width: 320px;
  height: 280px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.emoji-top {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 10px 8px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.emoji-search {
  flex: 1;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 8px 10px;
  outline: none;
}

.emoji-close {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  background: #fff;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.emoji-tabs {
  display: flex;
  gap: 6px;
  padding: 6px 10px;
  border-bottom: 1px solid #f0f0f0;
  overflow-x: auto;
}

.emoji-tab {
  border: none;
  background: #f6f6f6;
  border-radius: 10px;
  padding: 6px 8px;
  cursor: pointer;
  flex: 0 0 auto;
}
.emoji-tab.active {
  background: linear-gradient(135deg, #9c27b0, #673ab7);
  color: #fff;
}

.emoji-grid {
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 6px;
  overflow: auto;
  flex: 1;
}

.emoji-item {
  border: none;
  background: #fff;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  border-radius: 8px;
  padding: 6px 0;
}
.emoji-item:hover {
  background: #f3f3f3;
}

.emoji-empty {
  grid-column: 1 / -1;
  text-align: center;
  color: #777;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// EmojiPicker.vue?d6ac81f4